// GENERATED — DO NOT HAND-EDIT.
//
// Source of truth: specs/seeds/dashboard-v2/wizards/donor-create.yaml
// Generator: tools/v2-gen/v2genwiz.py
// Regenerate via: make v2-generate-wizards
//
// Hand-edits to non-override-block content WILL be lost on next
// regeneration. See specs/_product/dashboard-v2-wizard-generator.md
// for override-block doctrine (imports / helpers / submit).

import { useNavigate } from "react-router-dom";
import { WizardHost } from "./WizardHost";
import { donorCreateManifest } from "../generated/wizardManifests";
import { apiClient } from "../api/client";
// override-block:imports BEGIN
// override-block:imports END

// override-block:helpers BEGIN
// override-block:helpers END

export interface DonorCreateWizardProps {
  open: boolean;
  onClose: () => void;
}

export function DonorCreateWizard({ open, onClose }: DonorCreateWizardProps) {
  const navigate = useNavigate();
  // override-block:submit BEGIN
  const onSubmitRequest = async (values: Record<string, unknown>) => {
    const r = await apiClient().post<{ id: string }>("/donors", values);
    onClose();
    navigate(`/donors/${r.data.id}`);
  };
  // override-block:submit END
  return (
    <WizardHost
      manifest={donorCreateManifest}
      open={open}
      onClose={onClose}
      onSubmitRequest={onSubmitRequest}
    />
  );
}
